import { render } from "./EmployerDashboard.vue?vue&type=template&id=72acefa4&ts=true"
import script from "./EmployerDashboard.vue?vue&type=script&lang=ts"
export * from "./EmployerDashboard.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__